<template>
  <div class="page-wrapper">

    <h3>基本信息</h3>
    <div class="item ">
      <div class="flex">
        <span class="left">业主名称：</span>
        <span class="bold">{{data.ownerName}}</span>
      </div>
    </div>
    <div class="item">
      <span class="left">业主类型：</span>
      <span class="bold">{{data.ownerType==1?'企业':'个人'}}</span>
    </div>

    <!--<div v-if="data.ownerType==1">-->
    <div class="item" v-if="data.ownerType==1">
      <span class="left">组织机构代码：</span>
      <a href="javascript:;" v-if="!data.isShow1" @click="show('isShow1')">查看</a>
      <span class="bold" v-else>{{data.ownerBusinessCode}}</span>
    </div>
    <div class="item" v-if="data.ownerType==1">
      <span class="left">法定代表人：</span>
      <span class="bold">{{data.ownerLegalRepresent}}</span>
    </div>
    <div class="item" v-if="data.ownerType==1">
      <span class="left">法人身份证号：</span>
      <a href="javascript:;" v-if="!data.isShow2" @click="show('isShow2')">查看</a>
      <span class="bold" v-else>{{data.ownerOperatorIdcard}}</span>
    </div>
    <!--</div>-->

    <!--<div v-if="data.ownerType==2">-->
    <div class="item" v-if="data.ownerType==2">
      <span class="left">业主身份证号：</span>
      <a href="javascript:;" v-if="!data.isShow3" @click="show('isShow3')">查看</a>
      <span class="bold" v-else>{{data.ownerIdcard}}</span>
    </div>
    <div class="item" v-if="data.ownerType==2">
      <span class="left">产权人：</span>
      <span class="bold">{{data.propertyers && data.propertyers[0].propertyer}}</span>
    </div>

    <div class="item" v-if="data.ownerType==2">
      <span class="left">产权人身份证号：</span>
      <a href="javascript:;" v-if="!data.isShow4" @click="show('isShow4')">查看</a>
      <span class="bold" v-else>{{ data.propertyers&&data.propertyers[0].propertyerIdcard}}</span>
    </div>

    <!--</div>-->


    <div class="item">
      <div class="flex">


      <span class="left">收楼合同号：</span>
      <span class="bold">{{data.ownerHouseContract}}</span>
      </div>
    </div>


    <div class="item">
      <span class="left">业主联系人：</span>
      <span class="bold">{{data.ownerUser}}</span>
    </div>


    <div class="item">
      <span class="left">联系电话：</span>
      <a href="javascript:;" v-if="!data.isShow5" @click="show('isShow5')">查看</a>
      <span class="bold" v-else>{{data.ownerPhone}}</span>
    </div>
    <br>
    <div class="item">
      <span class="left">财务联系人：</span>
      <span class="bold">{{data.financeUser}}</span>
    </div>

    <div class="item">
      <span class="left">财务联系电话：</span>
      <a href="javascript:;" v-if="!data.isShow6" @click="show('isShow6')">查看</a>
      <span class="bold" v-else>{{data.financePhone}}</span>

    </div>

    <div class="item">
      <span class="left">开户银行：</span>
      <span class="bold">{{data.ownerBankName}}</span>
    </div>

    <br>

    <div class="item">
      <span class="left">银行账号：</span>
      <a href="javascript:;" v-if="!data.isShow7" @click="show('isShow7')">查看</a>
      <span class="bold" v-else>{{data.ownerBankCard}}</span>
    </div>

    <div class="item">
      <span class="left">经办人：</span>
      <span class="bold">{{data.ownerOperatorName}}</span>
    </div>

    <h3>附件</h3>

    <div class="item " v-if="data.ownerType==1">
      <span class="vt">组织机构代码附件:</span>
      <template v-for="item in  data.attachmentBusinessUrl">
        <img v-if="checkImgByUrl(item.attachmentImgUrl)" class="file-img" :src="item.attachmentImgUrl"
             @click.stop="showImg(item.attachmentImgUrl)" alt="">
        <a v-else :href="item.attachmentImgUrl"><img class="file-img" :src="defaultImg" alt=""></a>
      </template>
    </div>
    <div class="item ">
      <span class="vt">产权证附件:</span>

      <template v-for="item in  data.propertyImageUrl">
        <img v-if="checkImgByUrl(item.attachmentImgUrl)" class="file-img" :src="item.attachmentImgUrl"
             @click.stop="showImg(item.attachmentImgUrl)" alt="">
        <a v-else :href="item.attachmentImgUrl"><img class="file-img" :src="defaultImg" alt=""></a>
      </template>
    </div>

    <div class="item ">
      <span class="vt">其他附件:</span>
      <template v-for="item in  data.otherAttachments">
        <img v-if="checkImgByUrl(item.attachmentImgUrl)" class="file-img" :src="item.attachmentImgUrl"
             @click.stop="showImg(item.attachmentImgUrl)" alt="">
        <a v-else :href="item.attachmentImgUrl"><img class="file-img" :src="defaultImg" alt=""></a>

      </template>
    </div>
    <br>

    <div class="">
      <span>备注:</span>
      <span>{{data.remark}}</span>
    </div>
    <img-show :n="imgN" :src="imgSrc"></img-show>
  </div>
</template>

<script>

  import {checkImgByUrl} from "../../../../utils/public";
  import filedefault from '../../../../assets/filedefault.jpg';
  import {getOwnerInfo} from "../../../../api/owner";
  import ImgShow from 'components/ImgShow/index'

  export default {
    name: "OwnerInfo",
    components: {
      ImgShow
    },
    watch: {
      ownerId() {
        this.getOwnerInfo()
      }

    },
    data() {
      return {
        id: '',
        defaultImg: filedefault,
        data: {},
        imgSrc: '',
        imgN: 0
      }

    },
    methods: {
      showImg(data) {
        this.imgSrc = data
        this.imgN++

      },
      show(key) {
        this.data[key] = true

      },
      checkImgByUrl: checkImgByUrl,
      getOwnerInfo() {
        if (!this.id) {
          return
        }
        var params = {
          ownerId: this.id
        }
        getOwnerInfo(params).then(res => {
          res.data['isShow1'] = false
          res.data['isShow2'] = false
          res.data['isShow3'] = false
          res.data['isShow4'] = false
          res.data['isShow5'] = false
          res.data['isShow6'] = false
          res.data['isShow7'] = false
          this.data = res.data
        })
      }
    },
    created() {
      this.id = this.$route.params['id']
      this.getOwnerInfo()
    }
  }
</script>

<style scoped>
  /*.left {*/
  /*!*width: 80px;*!*/
  /*display: inline-block;*/
  /*}*/

  .item {
    display: inline-block;
    /*margin-right: 30px;*/
    line-height: 1;
    margin-bottom: 25px;
    vertical-align: top;
    width: 30%;
    vertical-align: top;
    margin-right: 10px;
    min-width: 150px;
  }

  .file-img {
    width: 200px;
    height: 130px;
    overflow: hidden;
    display: inline-block;
    margin-top: 10px;
  }

  .vt {
    vertical-align: top;
  }

  h3 {
    margin: 10px 0 25px 0;
    font-size: 12px;
  }

  .border-none {
    border: none;
  }
  .flex{
    display: flex;
  }

</style>
